import React from "react"
import { convert } from "ogham"
import { remove } from "diacritics"
import classnames from "classnames"

// The `ogham` library's convert() accepts letters and spaces, adds a single pair of feather marks
// around the whole text, and renders spaces as the Ogham space mark (a blank stem segment). It throws
// on any other character (punctuation, digits, leftover diacritics). So we sanitize to letters and
// single spaces but keep the text as ONE string, then convert once. This yields a single inscription
// (one boundary, space marks between words) instead of each word bracketed on its own.
export const format = (text: string): string => {
  const sanitized = remove(text || "")
    .replace(/[^a-zA-Z ]+/g, "")
    .replace(/\s+/g, " ")
    .trim()
  if (!sanitized) return ""
  return convert(sanitized, { usePhonetics: true })
}

export const OghamScript = ({
  text,
  className,
}: {
  text: string
  className?: string
}) => (
  <div className={classnames("text-3xl ogham-glyph", className)}>
    {format(text)}
  </div>
)

export default OghamScript
